<template>
  <div
    v-custom-click-outside="handleClickOutside"
    class="custom-select-wrapper"
    :tabindex="tabindex"
  >
    <div
      class="custom-select"
      :class="{ open: open, disabledSelect: disabled }"
      @click="handleToggleOpen"
    >
      <span
        v-if="!customDiscountOptions"
        class="selected-item-text"
        :class="{ disabledSelectText: disabled }"
      >
        {{ selected }}
      </span>

      <div
        v-if="customDiscountOptions"
      >
        {{ periodMonthsValue }}
        <span
          v-if="discount"
          class="payment-period-option-discount"
        >
          {{ `${$t('plans.discount')} ${discount}%` }}
        </span>
      </div>

      <img :src="arrowDownIcon" alt="Arrow down" />
    </div>
    <div
      v-if="!customDiscountOptions && !customCountriesOptions"
      class="items"
      :class="{ selectHide: !open }"
    >
      <v-tooltip
        v-for="(option, i) of options"
        :key="i"
        :disabled="!selectItemIsDisabled(option)"
        max-width="350"
        top
        nudge-bottom="8"
      >
        <template #activator="{ on }">
          <div
            class="option"
            :class="{ selectItemDisabled: selectItemIsDisabled(option) }"
            @click="handleSelect(option)"
            v-on="on"
          >
            <span>{{ option }}</span>
          </div>
        </template>

        <span v-html-safe="$t('common.selectFreePlan')" />
      </v-tooltip>
    </div>

    <div
      v-if="customDiscountOptions"
      class="items"
      :class="{ selectHide: !open }"
    >
      <div
        v-for="(option, i) of options"
        :key="i"
        class="option"
        @click="handleSelect(option)"
      >
        {{ option.text }}
        <span
          v-if="option.discount"
          class="payment-period-option-discount"
        >
          {{ `${$t('plans.discount')} ${option.discount}%` }}
        </span>
      </div>
    </div>

    <div
      v-if="customCountriesOptions"
      class="items"
      :class="{ selectHide: !open }"
    >
      <div
          v-for="(option, i) of options"
          :key="i"
          class="option"
          @click="handleSelect(option)"
      >
        {{ option.name }}
      </div>
    </div>
  </div>
</template>

<script>
  import arrowDownIcon from '../../assets/arrowDown.svg'
  import { mapGetters } from "vuex";
  import { FREE_TARIFF_NAME } from "@/constants/plans";
  import calculations from '@/mixins/calculations';

  export default {
    name: 'DolphinSelect',
    mixins: [calculations],
    props: {
      options: {
        type: Array,
        required: true,
      },

      default: {
        type: [String, Number],
        required: false,
        default: null,
      },

      tabindex: {
        type: Number,
        required: false,
        default: 0,
      },

      disabled: {
        type: Boolean,
        required: false,
        default: false
      },

      customDiscountOptions: {
        type: Boolean,
        required: false,
        default: false
      },

      customCountriesOptions: {
        type: Boolean,
        required: false,
        default: false
      }
    },

    data () {
      return {
        FREE_TARIFF_NAME,
        selected: typeof this.default !== 'undefined'
            ? this.default
            : this.options.length > 0 ? this.options[0] : null,
        open: false,
        discount: 0,
        arrowDownIcon
      };
    },

    computed: {
      ...mapGetters({
        paymentInfo: 'plans/paymentInfo',
        profile: 'main/profile'
      }),

      periodMonthsValue () {
        return this.options.find(elem => elem.value === this.paymentInfo.prolongMonths) ?
            this.options.find(elem => elem.value === this.paymentInfo.prolongMonths).text : this.paymentInfo.prolongMonths
      }
    },

    mounted () {
      this.$emit('input', this.selected)
    },

    methods: {
      selectItemIsDisabled (option) {
        return (
          option === 0 &&
          this.getDaysUntilExpiration(this.profile?.subscription?.expiration) > 0 &&
          (
            this.profile.subscription.plan !== FREE_TARIFF_NAME ||
            this.profile.subscription.browserProfiles.additionalProfiles > 0
          )
        )
      },

      handleToggleOpen () {
        if (this.disabled) {
          return
        }
        this.open = !this.open

        if (this.open) {
          this.$store.dispatch('plans/setPaymentSideScroll', true)
        } else {
          this.$store.dispatch('plans/setPaymentSideScroll', false)
        }
      },

      handleSelect (option) {
        if(this.selectItemIsDisabled(option)) return

        this.open = false

        if (this.customDiscountOptions) {
          this.selected = option.text
          this.discount = option.discount
          this.$emit('input', option.value)

          return
        }

        if (this.customCountriesOptions) {
          this.selected = option.name
          this.$emit('input', option.code)

          return
        }

        this.selected = option
        this.$emit('input', option)
      },

      handleClickOutside () {
        this.open = false
      }
    }
  };
</script>

<style scoped>
  .custom-select-wrapper {
    position: relative;
    width: 100%;
    text-align: left;
    outline: none;
    height: 40px;
    line-height: 40px;
  }

  .custom-select-wrapper .custom-select {
    width: 100%;
    height: 100%;
    background: #FFFFFF;
    border: 1px solid #939393;
    border-radius: 50px;
    padding: 6px 12px 6px 16px;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #000000;
    cursor: pointer;
    user-select: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    white-space: nowrap;
  }

  .selectItemDisabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .selected-item-text {
    margin-right: 10px;
    color: #000000;
  }

  .custom-select-wrapper .items {
    width: 100%;
    max-height: 194px;
    color: #fff;
    border-radius: 4px;
    overflow-x: hidden;
    position: absolute;
    left: 0;
    right: 0;
    z-index: 1;
    margin-top: 4px;
    background: #FFFFFF;
    border: 1px solid rgba(16, 24, 40, 0.1);
    box-shadow: 0 4px 10px rgba(33, 69, 98, 0.08);
  }

  .custom-select-wrapper .items div {
    color: #000000;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    padding: 16px 0 16px 20px;
    cursor: pointer;
    user-select: none;
  }

  .custom-select-wrapper .items div:hover {
    background: rgba(181, 71, 233, 0.08);
  }

  .selectHide {
    display: none;
  }

  .disabledSelect {
    background: rgba(200, 200, 200, 0.2)!important;
    border: 1px solid rgba(147, 147, 147, 0.5)!important;
    cursor: default!important;
  }

  .disabledSelectText {
    color: #A9ABB6;
  }

  .items .option {
    background: #FFFFFF;
  }

  .payment-period-option-discount {
    width: 98px;
    height: 20px;
    background: rgba(181, 71, 233, 0.1);
    border-radius: 4px;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 1.25px;
    text-transform: uppercase;
    color: #B547E9;
    margin-left: 5px;
    padding: 3px 6px;
  }
</style>
